import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface GreenhouseBay {
  id: string;
  greenhouseId: string;
  bayName: string;
  description: string;
  sizeSquareMeters: number;
  bedCount: number;
  trayCapacity: number;
  isActive: boolean;
  createdAt: string;
}

export interface CreateGreenhouseBayRequest {
  greenhouseId: string;
  bayName: string;
  description: string;
  sizeSquareMeters: number;
  bedCount: number;
  trayCapacity: number;
}

export const greenhouseBaysApi = {
  getBaysByGreenhouseId: async (
    greenhouseId: string
  ): Promise<GreenhouseBay[]> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseBay[]>>(
      `/GreenhouseBays/greenhouse/${greenhouseId}`
    );
    return data.data;
  },

  getBayById: async (id: string): Promise<GreenhouseBay> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseBay>>(
      `/GreenhouseBays/${id}`
    );
    return data.data;
  },

  createBay: async (
    payload: CreateGreenhouseBayRequest
  ): Promise<GreenhouseBay> => {
    const { data } = await apiClient.post<ApiResponse<GreenhouseBay>>(
      "/GreenhouseBays",
      payload
    );
    return data.data;
  },

  updateBay: async (
    id: string,
    payload: CreateGreenhouseBayRequest
  ): Promise<GreenhouseBay> => {
    const { data } = await apiClient.put<ApiResponse<GreenhouseBay>>(
      `/GreenhouseBays/${id}`,
      payload
    );
    return data.data;
  },

  deleteBay: async (id: string): Promise<void> => {
    await apiClient.delete(`/GreenhouseBays/${id}`);
  },
};